import React from "react";
import Container from "@mui/material/Container";
import resumePhoto from "../mainImg/mypic.png";
const Greeting = () => {
  return (
    <>
      <section className="greeting-section">
        <Container>
          <div className="greeting">
            <div className="col-xs-6 col-sm-6 col-md-6">
              <h1 className="greeting-title">
                Вітаю, мене звуть Діана, мені 26 і я починаючий Front-End
                Розробник
              </h1>
            </div>
            <div className=" resume-photo ">
              <img src={resumePhoto} alt="my-resume" />
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};
export default Greeting;
